import { call, takeLatest, put } from "redux-saga/effects"
import {
  requestApplications,
  requestDeleteApplication,
  requestCreateApplication,
  requestUpdateApplication,
} from "appRedux/sagas/requests/application"
import {
  getApplications,
  getApplicationsSuccess,
  deleteApplication,
  deleteApplicationSuccess,
  createApplications,
  createApplicationsSuccess,
  updateApplications,
  updateApplicationsSuccess,
} from "appRedux/slices/application"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function* handleGetApplications(params) {
  try {
    const data = yield call(requestApplications, params)
    yield put(getApplicationsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleDeleteApplication(params) {
  try {
    const data = yield call(requestDeleteApplication, params)
    yield put(deleteApplicationSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleCreateApplication(params) {
  try {
    const data = yield call(requestCreateApplication, params)
    yield put(createApplicationsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateApplication(params) {
  try {
    const data = yield call(requestUpdateApplication, params)
    if (data) {
      yield put(updateApplicationsSuccess(data))
    }
  } catch (error) {
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getApplications.type, handleGetApplications)
  yield takeLatest(deleteApplication.type, handleDeleteApplication)
  yield takeLatest(createApplications.type, handleCreateApplication)
  yield takeLatest(updateApplications.type, handleUpdateApplication)
}
